<template>
  <div>
    <modal
      name="videoModal"
      :scrollable="true"
      delay="2000"
      width="100%"
      height="auto"
      style="z-index: 9998;"
      @closed="closeModal"
    >
      <div id="modalAreaVideo" class="modalArea">
        <div class="content">
          <h2>日本写真100景を動画で</h2>
          <p>日本の美しい景観を育て、守り、成長させてくださっている方々に思いを寄せて、日本写真100景を動画でもお楽しみただけるスペシャルコンテンツをご用意しました。</p>

          <div class="video">
            <h3>4K 日本写真100景2020【春編】<br>～日本は発見を待っている。～</h3>
            <h4>4K Spring in Japan / Top 100 Photo Spots of Japan 2020 (Spring Version)</h4>
            <div class="videoContainer">
              <iframe width="100%" src="https://www.youtube.com/embed/uOSLdLuep8k" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>

          <div class="video">
            <h3>日本写真100景2020【沖縄/九州/四国編】<br>～日本は発見を待っている。～</h3>
            <h4>Top 100 Photo Spots of Japan 2020 (Okinawa/Kyushu/Shikoku Region Version)</h4>
            <div class="videoContainer">
              <iframe width="100%" src="https://www.youtube.com/embed/_fxYVuMkCtg" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
            </div>
          </div>
        </div><!-- /content -->
      </div><!-- /modalArea -->
      <div v-if="open" class="closeModalBotton fade" @click="closeModal"><img src="/img/blank.gif"></div>
    </modal>
  </div>
</template>

<script>
export default {
  props: [
    'open'
  ],
  methods: {
    closeModal () {
      this.$emit('update:open', false)
      this.$modal.hide('videoModal')
      const path = '/'
      if (path !== this.$route.path) {
        this.$router.push(path)
      }
      document.title = '東京カメラ部 日本写真100景 ～日本は発見を待っている。～'
    }
  },
  watch: {
    open (val) {
      if (val) {
        this.$modal.show('videoModal')
      }
    }
  }
}
</script>

<style>
.vm--overlay {
  background: rgba(0, 0, 0, 0.8) !important;
}
.vm--modal {
  background-color:rgba(0,0,0,0) !important;
}
</style>
